import { AxiosRequestConfig } from "axios";
import { AZURE_URL } from "../constants/env-constants";

export const loginUser = async (
  data: LoginUser,
  twoFactorAuthCode?: string
) => {
  try {
    const headers: AxiosRequestConfig["headers"] = {};
    headers["Two-Factor-Auth-Code"] = twoFactorAuthCode;
    const response = await AZURE_URL.post("/user/auth/token", data, {
      headers,
    });
    return [response.data, null];
  } catch (error: any) {
    return [null, error.response.data];
  }
};

export const getUser = async () => {
  try {
    const response = await AZURE_URL.get("/user/get");
    return response;
  } catch (error: any) {
    console.log(error);
    return error.response;
  }
};

export const preLoginCheck = async (data: LoginUser) => {
  try {
    const response = await AZURE_URL.post("/user/preLoginCheck", data);
    return [response.data, null];
  } catch (error: any) {
    return [null, error.response.data];
  }
};

export const firstPasswordReset = async (data: FirstPasswordReset) => {
  try {
    const response = await AZURE_URL.put("/user/resetAuth", data);
    return [response, null];
  } catch (error: any) {
    return [null, error.response.data];
  }
};

export const getQRAuthImage = async (data: QRAuthImage) => {
  try {
    const response = await AZURE_URL.put("/user/resetAuth", data);
    return [response.data, null];
  } catch (error: any) {
    return [null, error.response.data];
  }
};
